export const FINANCE_DETAILS = "FINANCE_DETAILS";
export const FINANCE_LOADER = "FINANCE_LOADER";
export const EDIT_FINANCE_DETAILS = "EDIT_FINANCE_DETAILS";
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
